import { render } from "./GoodsPacking.vue?vue&type=template&id=803bb292&scoped=true"
import script from "./GoodsPacking.vue?vue&type=script&lang=js"
export * from "./GoodsPacking.vue?vue&type=script&lang=js"

import "./GoodsPacking.vue?vue&type=style&index=0&id=803bb292&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-803bb292"]])

export default __exports__